import React from 'react';
import { Control } from 'react-hook-form';
import useLanguagesHooks from '../../../../../../../Components/Languages/setLanguage-hooks';
import ToggleSwitch from '../../../../../../../Components/ToggleSwitch/toggleSwitch';
import { isPosTerminalEnabled } from '../../../../../../../Utilits/utilits';
import styles from './orderPaymentSection.module.scss';
import { WithPaymentFields } from './useOrderPayment';

interface IProps<T extends WithPaymentFields = WithPaymentFields> {
    pos_terminal?: boolean | null;
    control: Control<T>;
}

const OrderPaymentSection = <T extends WithPaymentFields>({ pos_terminal, control }: IProps<T>) => {
    const { t } = useLanguagesHooks();

    if (!isPosTerminalEnabled(pos_terminal)) {
        return null;
    }

    return (
        <div className={styles.paymentBox}>
            <p className={styles.paymentLabel}>{t('Visitor.Delivery.Payment')}</p>
            <div className={styles.switcherBox}>
                <div className={styles.switcherRow}>
                    <p>{t('Visitor.Delivery.Cash')}</p>
                    <ToggleSwitch control={control} name='cash' />
                </div>
                <div className={styles.switcherRow}>
                    <p>{t('Visitor.Delivery.Card')}</p>
                    <ToggleSwitch control={control} name='card' />
                </div>
            </div>
        </div>
    );
};

export default OrderPaymentSection;
